import * as services from '@/services/survey'
import { Message, MessageBox } from '@gcommon/gcommon-ui'
/**
 * @modalEditOrNewState
 * 新建编辑查看弹窗
 *
 * @evTagModalState
 * 事件标识配置弹窗
 *
 * @msgTempModalState
 * 消息模板配置弹窗
 *
 * @msgFilterModalState
 * 消息过滤规则配置弹窗
 *
 * @originMsgModalState
 * 源消息示例弹窗
 */
const state = {
  modalEditOrNewState:{
    visible:false,
    modalStatus:'add',
    data:{},
    dataForEdit:{}
  },
  evTagModalState:{
    visible:false,
    modalStatus:'add',
    data:{},
    dataForEdit:{}
  },
  msgTempModalState:{
    visible:false,
    modalStatus:'add',
    data:{},
    dataForEdit:{}
  },
  msgFilterModalState:{
    visible:false,
    modalStatus:'add',
    data:{},
    dataForEdit:{}
  },
  originMsgModalState:{
    visible:false,
    modalStatus:'add',
    data:{},
    dataForEdit:{}
  },
  validateFieldEventRule:'',
  validateFieldDtoTemplate:'',
}

const mutations = {
  commonMutations: (state, payload) => {
    Object.keys(payload).forEach(item => {
      state[item] = payload[item]
    })
  },
  initState: (state, payload) => {
    state.modalEditOrNewState={
      visible:false,
      modalStatus:'add',
      data:{},
      dataForEdit:{}
    }
    state.evTagModalState={
      visible:false,
      modalStatus:'add',
      data:{},
      dataForEdit:{}
    }
    state.msgTempModalState={
      visible:false,
      modalStatus:'add',
      data:{},
      dataForEdit:{}
    }
    state.msgFilterModalState={
      visible:false,
      modalStatus:'add',
      data:{},
      dataForEdit:{}
    }
    state.originMsgModalState={
      visible:false,
      modalStatus:'add',
      data:{},
      dataForEdit:{}
    }
    state.validateFieldEventRule = ''
    state.validateFieldDtoTemplate = ''
  },
}

const actions = {
  getSurveyDetailDraft({ state, commit }, payload) {
    services.checkSurveyDetialService(payload).then(res => {
      if (res?.code == 200) {
        // commit('initState',res.data)
        // initSurveyData()
      }
    })
  },
  getSurveyDetailNoDraft({ state, commit }, payload) {
    services.checkSurveyDetialService(payload).then(res => {
      if (res?.code == 200) {
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
